export const WAVE_HEIGHTS = [10, 18, 24, 16, 28, 20, 14, 22, 12, 26, 18];

export const VOL_BG = 0.02;

export const VOL_SPIN = 0.8;

export const VOL_WIN = 0.3;

export function createWheelAudioController({ spinSound, winningSound, bgMusic, soundMuted, soundPlaying, spinDuration }) {
    const updateSoundPlayingState = () => {
        const refs = [spinSound, winningSound, bgMusic];
        soundPlaying.value = refs.some((audioRef) => {
            const audio = audioRef?.value;

            return !!audio && !audio.paused;
        });
    };

    const setVolumes = () => {
        if (bgMusic.value) bgMusic.value.volume = VOL_BG;

        if (spinSound.value) spinSound.value.volume = VOL_SPIN;

        if (winningSound.value) winningSound.value.volume = VOL_WIN;
    };

    const startBgMusic = () => {
        if (soundMuted.value || !bgMusic.value) return;

        if (!bgMusic.value.paused) {
            updateSoundPlayingState();
            return;
        }

        bgMusic.value.currentTime = 0;
        bgMusic.value.volume = VOL_BG;
        bgMusic.value
            .play()
            .then(() => {
                updateSoundPlayingState();
            })
            .catch(() => {
                updateSoundPlayingState();
            });
    };

    const toggleSound = () => {
        soundMuted.value = !soundMuted.value;

        if (soundMuted.value) {
            [spinSound, winningSound, bgMusic].forEach((audioRef) => {
                if (!audioRef.value) return;

                audioRef.value.pause();
                audioRef.value.currentTime = 0;
            });
            updateSoundPlayingState();
        } else {
            startBgMusic();
        }
    };

    const playSpinSound = () => {
        if (soundMuted.value || !spinSound.value) return;

        spinSound.value.currentTime = 0;
        spinSound.value.volume = VOL_SPIN;
        spinSound.value
            .play()
            .then(() => {
                updateSoundPlayingState();
            })
            .catch(() => {
                updateSoundPlayingState();
            });

        setTimeout(() => {
            if (spinSound.value) {
                spinSound.value.pause();

                spinSound.value.currentTime = 0;
            }

            updateSoundPlayingState();
        }, spinDuration + 500);
    };

    const playWinningSound = () => {
        if (soundMuted.value || !winningSound.value) return;

        winningSound.value.currentTime = 0;
        winningSound.value.volume = VOL_WIN;
        winningSound.value
            .play()
            .then(() => {
                updateSoundPlayingState();
            })
            .catch(() => {
                updateSoundPlayingState();
            });

        winningSound.value.onended = () => {
            updateSoundPlayingState();
        };
    };

    const stopAllSounds = () => {
        [spinSound, winningSound, bgMusic].forEach((audioRef) => {
            if (!audioRef.value) return;

            audioRef.value.pause();
        });
        updateSoundPlayingState();
    };

    return {
        setVolumes,
        startBgMusic,
        toggleSound,
        playSpinSound,
        playWinningSound,
        stopAllSounds
    };
}
